import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { updateAnalyticsConsent } from '../utils/analytics';

// Cookie / analytics consent banner.
// - Shows only after the age gate has been passed (rendered inside App
//   after AgeGate resolves).
// - Remembers the visitor's choice in localStorage under 'nb_analytics_consent'.
// - Age verification is intentionally separate from analytics consent.
const STORAGE_KEY = 'nb_analytics_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let choice = null;
    try { choice = window.localStorage.getItem(STORAGE_KEY); } catch (_) { /* ignore */ }
    if (!choice) setVisible(true);
  }, []);

  const decide = (accepted) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected');
    } catch (_) { /* ignore */ }
    updateAnalyticsConsent(accepted);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="nb-cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Cookies and analytics consent"
      data-testid="cookie-consent-banner"
    >
      <div className="nb-cookie-copy">
        <p className="nb-cookie-title">COOKIES &amp; ANALYTICS</p>
        <p className="nb-cookie-text">
          We use Google Analytics via Google Tag Manager to understand aggregated
          website usage — approximate country, state and city, pages viewed and
          campaign attribution. No personal information is sent. Read our{' '}
          <Link to="/privacy" className="nb-inline-link">Privacy Policy</Link>.
        </p>
      </div>
      <div className="nb-cookie-actions">
        <button
          type="button"
          className="nb-cookie-btn nb-cookie-btn-ghost"
          onClick={() => decide(false)}
          data-testid="cookie-reject-btn"
        >
          Reject
        </button>
        <button
          type="button"
          className="nb-cookie-btn nb-cookie-btn-primary"
          onClick={() => decide(true)}
          data-testid="cookie-accept-btn"
        >
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
